import { DEFAULT_PAYMENT_LINKS } from '../mocks/paymentLinks';

type Links = typeof DEFAULT_PAYMENT_LINKS;

export function getPaymentLink(niveau: keyof Links): string {
  return DEFAULT_PAYMENT_LINKS[niveau];
}
